import { useContext } from 'react';
import {
    Table, TableBody, TableCell,
    TableHead, TablePagination, TableRow, TableFooter, Typography
} from '@mui/material';
import { shipmentTypesContext } from '../ShipmentTypesContext';
import { CircleLoader, DeleteIconButton, EditIconButton } from 'components';

let Results = () => {
    let service = useContext(shipmentTypesContext);

    return (
        <div>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <>
                    <TablePagination
                        component="div"
                        count={service.recordCount}
                        onPageChange={service.handleChangePage}
                        page={service.search.pageNr}
                        rowsPerPage={service.search.pageSize}
                        rowsPerPageOptions={[service.search.pageSize]}
                        labelDisplayedRows={(props) => {
                            let pageSize = props.to - props.from + 1
                            return (
                                <>
                                    Total Shipment Types:&nbsp;{service.recordCount} &nbsp;&middot;&nbsp;
                                    <span>Page {props.page + 1} of {Math.ceil(props.count / pageSize)}</span>
                                </>
                            )
                        }}
                    />

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Code</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {service.shipmentTypes.length > 0 &&
                                service.shipmentTypes
                                    .map((shipmentType, index) =>
                                        <TableRow hover key={index}>
                                            <TableCell>{shipmentType.code}</TableCell>
                                            <TableCell>{shipmentType.description}</TableCell>
                                            <TableCell align="right">
                                                <EditIconButton link={`/admin/shipmenttype/edit/${shipmentType.shipmentTypeId}`} />
                                                <DeleteIconButton onClick={() => service.deleteShipmentType(shipmentType.shipmentTypeId)} />
                                            </TableCell>
                                        </TableRow>
                                    )}
                        </TableBody>
                        {service.shipmentTypes.length === 0 &&
                            <TableFooter>
                                <TableRow>
                                    <TableCell colSpan={3}>
                                        <Typography variant="subtitle2">No Shipment Types found</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        }
                    </Table>

                    <TablePagination
                        component="div"
                        count={service.recordCount}
                        onPageChange={service.handleChangePage}
                        page={service.search.pageNr}
                        rowsPerPage={service.search.pageSize}
                        rowsPerPageOptions={[service.search.pageSize]}
                    />

                </>
            }
        </div>
    );
}

export default Results;